import React from "react";
import "./App.css";
import Header from "./components/Header.jsx";
import Hero from "./components/Hero.jsx";
import About from "./components/About.jsx";
import Slogan from "./components/Slogan.jsx";
import VideoSection from "./components/VideoSection.jsx";
import Services from "./components/Services.jsx";
import GalleryCarousel from "./components/GalleryCarousel.jsx";
import Contact from "./components/Contact.jsx";
import Footer from "./components/Footer.jsx";

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <About />
        <Slogan />
        <GalleryCarousel />
        <Services />
        <VideoSection />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
